import { render } from "./FrostAlertIcon.vue?vue&type=template&id=173babac"
import script from "./FrostAlertIcon.vue?vue&type=script&lang=js"
export * from "./FrostAlertIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__